













































































































import { Component, Vue } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import FormFilter from './components/FormFilter.vue';
import SrsForm from './components/SrsForm.vue';
import SrsReport from './components/SrsReport.vue';
import SrsAgree from './components/SrsAgree.vue';
import SrsParsing from './components/SrsParsing.vue';


interface IFilterData {
    ate?: any;
    district?: any;
    ruralDistrict?: any;
    snp?: any;
    year: any;
    direction?: any;
}

interface IAgreeFilterData {
    ate: any;
    district: any;
    ruralDistrictList: any;
    ruralDistrict: any;
    snpList: any;
    snp: any;
    year: any;
    directionList: any;
    direction: any;
}


@Component({
    components: {
        'multiselect': Multiselect, 
        'FormFilter': FormFilter,
        'SrsForm': SrsForm, 
        'SrsReport': SrsReport,
        'SrsAgree': SrsAgree,
        'SrsParsing': SrsParsing,
    }
})
export default class RegionalStandardsSystem extends Vue {
    filterData: IFilterData | null = null;
    agreeFilterData: IAgreeFilterData | null = null;
    formKey: number = 0; 
    agreeFormKey: number = 0;
    isSrsReportAccessGranted: boolean = true;
    UserAccessLevelForSrsAgreement: number = 0;
    userParsingAccessLevel: number = 0;

    async mounted() {
        await this.getUserAccessLevelForSrsAgreement(); 
        this.userParsingAccessLevel = await this.getUserAccessLevel('003.009.004');
    }

    onDefaultFilter(data: IFilterData) {
        this.filterData = data;
        this.formKey++; 
    }

    onFilterApplied(data: IFilterData) {
        this.filterData = data;
        this.formKey++; // force form to re-render 
    }

    onFilterReset(data: IFilterData) {
        this.filterData = data;
        this.formKey++;  
    }

    onAgreementDefaultFilter(data: IAgreeFilterData) {
        this.agreeFilterData = { ...data };
    }

    onAgreementFilterApplied(data: IAgreeFilterData) {
        this.agreeFilterData = { ...data };
        this.agreeFormKey++; 
    }

    onAgreementFilterReset(data: IAgreeFilterData) {
        this.agreeFilterData = data;
        this.agreeFormKey++;  
    }

    handleSrsReportAccess(accessData: boolean) {
        this.isSrsReportAccessGranted = accessData;
    }

    get isSrsAgreeAccessGranted(): boolean {
        return this.UserAccessLevelForSrsAgreement !== null
        && this.UserAccessLevelForSrsAgreement > 0;
    }

    async getUserAccessLevelForSrsAgreement() {
        try {
            const userData = { 
              userId: this.$store.getters.user_uuid,
              moduleCode: '003.009.003' 
            };
            const response = await fetch('/api-py/srs/user/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const accessLevel = await response.json();
            this.UserAccessLevelForSrsAgreement = accessLevel; 

        } catch (error) {
            this.UserAccessLevelForSrsAgreement = 0;
            const err = error as Error;
        }
    }

    async getUserAccessLevel(moduleCode: string) {
        try {
            const userData = {
                userId: this.$store.getters.user_uuid,
                moduleCode: moduleCode,
            };

            const response = await fetch('/api-py/srs/user/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const accessLevel = await response.json();
            return accessLevel;

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.getUserAccessLevel_error')),
                err.message || err.toString()
            );

        }
    }

    makeToast(variant: string, tostbody: string, title: string, autoHideDelay?: number): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: autoHideDelay || 3500,
            solid: true
        });
    }
    
}

